export class RuleWrapperDTO {
    Rules: RuleDTO[];
}

export class RuleDTO {
    houseId: string;
    deviceId: string;
    moduleId: any;
    correlationId: string;
    type: string;
    rules: {
        desired: {
            enabled: boolean;
            rules: RuleDefinitionDTO[];
        },
        reported: {
            enabled: boolean;
            rules: RuleDefinitionDTO[];
        }
    };
}

export class RuleDefinitionDTO {
    state: boolean;
    moduleId: string;
    moduleIds: string[];
    powerLimit: number;
    power: number;
    type: string;
    activity: {
        start: {
            hour: number;
            minute: number;
        },
        end: {
            hour: number;
            minute: number;
        },
        startRepeat: {
            daysOfWeek: number[];
        },
        startAction: {
            command: string;
            setpoint: number;
            mode: string;
        }
    };
    ruleType: string;
}





// WEBPACK FOOTER //
// ./src/app/shared/DTO/RuleDTO.ts